import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { UpdateCompanyName } from '../editCompany/updateCompanyName';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/companies/oneCompanyDetails/companyDetailsHeader.css';

const CompanyDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/entreprises');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const CompanyDetailsData = useSelector((state) => state.CompanyDetailsData);

    const hasCompanyUpdatePermission = useHasPermission('entreprise_update');
    const hasCompanyDeletePermission = useHasPermission('entreprise_delete');

    const [errMsg, setErrMsg] = useState('');
    const [openEditCompanyName, setOpenEditCompanyName] = useState(false);
    const [openDeleteCompany, setOpenDeleteCompany] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleOpenActionMenu = (event) => setAnchorEl(event.currentTarget);

    const handleCloseActionMenu = () => setAnchorEl(null);

    const handleGoBack = goBack;

    const handleDeleteCompany = async () => {
        try {
            const response = await axios.delete(`company/${CompanyDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setOpenDeleteCompany(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message)
            console.error('Erreur lors de la suppression de l’entreprise :', error);
            CustomErrorLogger(error, 'Suppression échouée dans DeleteCompany');
        }
    }

    return (
        <Box className="companyDetailsHeader_mainBox">
            <Box className="companyDetailsHeader_firstPart">
                <Iconify className='companyDetailsHeader_back_icon' icon="material-symbols:arrow-back" onClick={handleGoBack} />
                <Typography className="companyDetailsHeader_title">{CompanyDetailsData?.name}</Typography>
                {hasCompanyUpdatePermission && <Iconify className='companyDetailsHeader_edit_icon' icon="ic:outline-edit" onClick={() => setOpenEditCompanyName(true)} />}
            </Box>
            <Box className="companyDetailsHeader_secondPart">
                {isDesktop && hasCompanyDeletePermission &&
                    <Box className='companyDetailsHeader_action_box' onClick={() => setOpenDeleteCompany(true)}>
                        <Iconify className='companyDetailsHeader_delete_icon' icon="ic:outline-delete" />
                        <Typography className="companyDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='companyDetailsHeader_dots_icon'
                    icon="vaadin:ellipsis-dots-v"
                    id="companyPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />
                }
                <Menu
                    id="companyPageActionMenu"
                    MenuListProps="companyPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasCompanyDeletePermission &&
                        <MenuItem className='companyDetailsHeader_menuItem' onClick={() => setOpenDeleteCompany(true)}>
                            <Iconify className='companyDetailsHeader_delete_icon' icon="ic:outline-delete" />
                            <Typography className='companyDetailsHeader_delete_title'>{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {openEditCompanyName &&
                <UpdateCompanyName
                    openEditCompanyName={openEditCompanyName}
                    setOpenEditCompanyName={setOpenEditCompanyName}
                />
            }

            {openDeleteCompany &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={openDeleteCompany}
                    setOpenDelete={setOpenDeleteCompany}
                    handleDelete={handleDeleteCompany}
                    title="Êtes-vous sûr de vouloir supprimer cette entreprise ?"
                />
            }
        </Box>
    );
}

export default CompanyDetailsHeader;